export enum ScreenWidthPixelsBreakpoints {
	narrow = 1600,
	small = 1200,
	mobile = 768,
}
